const animalsData = {
  bear: {
    animalId: 'bear',
    food: 'honey',
    name: 'bear',
    difficulty: 2,
  },
  beaver: {
    animalId: 'beaver',
    food: 'wood',
    name: 'beaver',
    difficulty: 2,
  },
  bird: {
    animalId: 'bird',
    food: 'worms',
    name: 'bird',
    difficulty: 2,
  },
  butterfly: {
    animalId: 'butterfly',
    food: 'insects',
    name: 'butterfly',
    difficulty: 2,
  },
  cat: {
    animalId: 'cat',
    food: 'fish',
    name: 'cat',
    difficulty: 1,
  },
  chameleon: {
    animalId: 'chameleon',
    food: 'insects',
    name: 'chameleon',
    difficulty: 2,
  },
  chick: {
    animalId: 'chick',
    food: 'worms',
    name: 'chick',
    difficulty: 2,
  },
  chicken: {
    animalId: 'chicken',
    food: 'worms',
    name: 'chicken',
    difficulty: 2,
  },
  cow: {
    animalId: 'cow',
    food: 'grass',
    name: 'cow',
    difficulty: 1,
  },
  // crab: {
  //   animalId: 'crab',
  //   name: 'crab',
  //   difficulty: 1,
  // },
  deer: {
    animalId: 'deer',
    food: 'leaves',
    name: 'deer',
    difficulty: 1,
  },
  dog: {
    animalId: 'dog',
    food: 'meat',
    name: 'dog',
    difficulty: 1,
  },
  donkey: {
    animalId: 'donkey',
    food: 'straw',
    name: 'donkey',
    difficulty: 1,
  },
  duck: {
    animalId: 'duck',
    food: 'plants',
    name: 'duck',
    difficulty: 2,
  },
  elephant: {
    animalId: 'elephant',
    food: 'plants',
    name: 'elephant',
    difficulty: 2,
  },
  fish: {
    animalId: 'fish',
    food: 'seaweed',
    name: 'fish',
    difficulty: 2,
  },
  fox: {
    animalId: 'fox',
    food: 'meat',
    name: 'fox',
    difficulty: 2,
  },
  frog: {
    animalId: 'frog',
    food: 'insects',
    name: 'frog',
    difficulty: 1,
  },
  giraffe: {
    animalId: 'giraffe',
    food: 'the tall leaves',
    name: 'giraffe',
    difficulty: 2,
  },
  gingerbread: {
    animalId: 'gingerbread',
    food: 'sugar',
    name: 'gingerbread',
    difficulty: 2,
  },
  // hippo: {
  //   animalId: 'hippo',
  //   name: 'hippo',
  //   difficulty: 2,
  // },
  lion: {
    animalId: 'lion',
    food: 'meat',
    name: 'lion',
    difficulty: 2,
  },
  // ladybird: {
  //   animalId: 'ladybird',
  //   name: 'ladybird',
  //   difficulty: 2,
  // },
  monkey: {
    animalId: 'monkey',
    food: 'bananas',
    name: 'monkey',
    difficulty: 2,
  },
  // mosquito: {
  //   animalId: 'mosquito',
  //   name: 'mosquito',
  //   difficulty: 2,
  // },
  // mouse: {
  //   animalId: 'mouse',
  //   name: 'mouse',
  //   difficulty: 2,
  // },
  // octopus: {
  //   animalId: 'octopus',
  //   name: 'octopus',
  //   difficulty: 2,
  // },
  ostrich: {
    animalId: 'ostrich',
    food: 'plants',
    name: 'ostrich',
    difficulty: 2,
  },
  owl: {
    animalId: 'owl',
    food: 'insects',
    name: 'owl',
    difficulty: 2,
  },
  panda: {
    animalId: 'panda',
    food: 'bamboo',
    name: 'panda',
    difficulty: 2,
  },
  penguin: {
    animalId: 'penguin',
    food: 'fish',
    name: 'penguin',
    difficulty: 2,
  },
  pig: {
    animalId: 'pig',
    food: 'fruits',
    name: 'pig',
    difficulty: 1,
  },
  polarbear: {
    animalId: 'polarbear',
    food: 'fish',
    name: 'polar bear',
    difficulty: 2,
  },
  rabbit: {
    animalId: 'rabbit',
    food: 'carrots',
    name: 'rabbit',
    difficulty: 2,
  },
  racoon: {
    animalId: 'racoon',
    food: 'meat',
    name: 'racoon',
    difficulty: 2,
  },
  raindeer: {
    animalId: 'raindeer',
    food: 'carrots',
    name: 'raindeer',
    difficulty: 2,
  },
  rooster: {
    animalId: 'rooster',
    food: 'worms',
    name: 'rooster',
    difficulty: 2,
  },
  santa: {
    animalId: 'santa',
    food: 'cookies and mince pies',
    name: 'santa',
    difficulty: 1,
  },
  shark: {
    animalId: 'shark',
    food: 'fish',
    name: 'shark',
    difficulty: 2,
  },
  sheep: {
    animalId: 'sheep',
    food: 'grass',
    name: 'sheep',
    difficulty: 2,
  },
  snowman: {
    animalId: 'snowman',
    food: 'ice cubes',
    name: 'snowman',
    difficulty: 2,
  },
  hedgehog: {
    animalId: 'hedgehog',
    food: 'berries',
    name: 'hedgehog',
    difficulty: 2,
  },
  snail: {
    animalId: 'snail',
    food: 'plants',
    name: 'snail',
    difficulty: 2,
  },
  squid: {
    animalId: 'squid',
    food: 'fish',
    name: 'squid',
    difficulty: 2,
  },
  squirrel: {
    animalId: 'squirrel',
    food: 'nuts',
    name: 'squirrel',
    difficulty: 2,
  },
  tiger: {
    animalId: 'tiger',
    food: 'meat',
    name: 'tiger',
    difficulty: 2,
  },
  walrus: {
    animalId: 'walrus',
    food: 'clams',
    name: 'walrus',
    difficulty: 1,
  },
  wolf: {
    animalId: 'wolf',
    food: 'meat',
    name: 'wolf',
    difficulty: 1,
  },
  zebra: {
    animalId: 'zebra',
    food: 'grass',
    name: 'zebra',
    difficulty: 1,
  },
};

export default animalsData;


// WEBPACK FOOTER //
// ./src/data/animalsData.js